<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h3>Search Applications</h3>
    </v-flex>
    <v-layout pt-2 class="search-fields" column v-on:keyup.enter="search">
      <v-select
        v-model="query.submitted"
        :items="submittedItems"
        label="Application Status"
      ></v-select>
      <v-select
        v-model="query.status"
        :items="items"
        label="Application Status"
      ></v-select>
      <v-btn @click="search" color="blue" dark class="text-none">Search</v-btn>
    </v-layout>
    <v-layout column pt-3>
      <v-flex pb-3>
        <h3>Navigation</h3>
      </v-flex>
      <router-link to="/drivers">
        <h4>Drivers</h4>
      </router-link>
      <router-link to="/invoices">
        <h4>Invoices</h4>
      </router-link>
      <router-link to="/taxis">
        <h4>Taxis</h4>
      </router-link>
      <router-link to="/drivers/create">
        <h4>Register Driver</h4>
      </router-link>
    </v-layout>
  </v-layout>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "driver_search_box",
  props: {
    query: Object,
  },
  data: function () {
    return {
      rideTypes: null,
      submittedItems: ["Submitted", "In Progress", "All"],
      items: ["Rejected", "Accepted", "Pending Decision"],
    };
  },
  mounted: async function () {
    this.getTaxiInformation();
  },
  methods: {
    fromChanged: function (d) {
      this.query.after = d;
    },
    toChanged: function (d) {
      this.query.before = d;
    },
    search: function () {
      this.$emit("search");
    },
    clear: function () {
      this.$emit("clear");
    },
    getTaxiInformation: async function () {
      console.log("test");
      try {
        let url = `${this.$store.state.apiUrl}/taxi/getCouncilAndRideTypesForCreateTaxi`;
        let response = await axios.get(url, {
          params: {},
        });
        this.rideTypes = [];
        this.rideTypes.push({
          name: "",
          id: -1,
        });
        this.rideTypes = this.rideTypes.concat(response.data.ride_types);
      } catch (error) {
        console.log(
          "Failed to get information required to create taxi " + error
        );
      }
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
